import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './footer.module.scss';

const NavHeading = ({text}) => (
  <div>
    <hr className={styles.NavHeading__rule} />
    <h2
      className={classNames(
        'is-size-7',
        'has-text-grey-light',
        'is-uppercase',
        styles.NavHeading__text
      )}
    >
      {text}
    </h2>
  </div>
);

NavHeading.propTypes = {
  text: PropTypes.string.isRequired,
};

export default NavHeading;



// WEBPACK FOOTER //
// ./src/components/footer/NavHeading.js